import * as Types from './api-client.types';
export * from './api-client.types';

//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import type { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export * as WarrantyRequestClient from './api-client/WarrantyRequestClient';

export * as WarrantyRequestQuery from './api-client/WarrantyRequestQuery';



export * as WarrantyRequestSummaryClient from './api-client/WarrantyRequestSummaryClient';

export * as WarrantyRequestSummaryQuery from './api-client/WarrantyRequestSummaryQuery';



export * as WarrantyRequestBasketClient from './api-client/WarrantyRequestBasketClient';

export * as WarrantyRequestBasketQuery from './api-client/WarrantyRequestBasketQuery';



export * as UserClient from './api-client/UserClient';

export * as UserQuery from './api-client/UserQuery';



export * as TestApiClient from './api-client/TestApiClient';

export * as TestApiQuery from './api-client/TestApiQuery';



export * as TelehealthBillingClient from './api-client/TelehealthBillingClient';

export * as TelehealthBillingQuery from './api-client/TelehealthBillingQuery';



export * as SharePointClient from './api-client/SharePointClient';

export * as SharePointQuery from './api-client/SharePointQuery';



export * as ServicePresentationClient from './api-client/ServicePresentationClient';

export * as ServicePresentationQuery from './api-client/ServicePresentationQuery';



export * as ServiceAndRepairClient from './api-client/ServiceAndRepairClient';

export * as ServiceAndRepairQuery from './api-client/ServiceAndRepairQuery';



export * as SerialNumberClient from './api-client/SerialNumberClient';

export * as SerialNumberQuery from './api-client/SerialNumberQuery';



export * as SemiAdminClient from './api-client/SemiAdminClient';

export * as SemiAdminQuery from './api-client/SemiAdminQuery';



export * as SearchClient from './api-client/SearchClient';

export * as SearchQuery from './api-client/SearchQuery';



export * as RepairsAdminClient from './api-client/RepairsAdminClient';

export * as RepairsAdminQuery from './api-client/RepairsAdminQuery';



export * as RepairsClient from './api-client/RepairsClient';

export * as RepairsQuery from './api-client/RepairsQuery';



export * as RepairsOrderClient from './api-client/RepairsOrderClient';

export * as RepairsOrderQuery from './api-client/RepairsOrderQuery';



export * as QualificationClient from './api-client/QualificationClient';

export * as QualificationQuery from './api-client/QualificationQuery';



export * as ProfessionalInfoClient from './api-client/ProfessionalInfoClient';

export * as ProfessionalInfoQuery from './api-client/ProfessionalInfoQuery';



export * as PriceListsClient from './api-client/PriceListsClient';

export * as PriceListsQuery from './api-client/PriceListsQuery';



export * as PlanChartsClient from './api-client/PlanChartsClient';

export * as PlanChartsQuery from './api-client/PlanChartsQuery';



export * as OutstandingReceivablesClient from './api-client/OutstandingReceivablesClient';

export * as OutstandingReceivablesQuery from './api-client/OutstandingReceivablesQuery';



export * as OrderListClient from './api-client/OrderListClient';

export * as OrderListQuery from './api-client/OrderListQuery';



export * as NotificationClient from './api-client/NotificationClient';

export * as NotificationQuery from './api-client/NotificationQuery';



export * as KonditionsBlattClient from './api-client/KonditionsBlattClient';

export * as KonditionsBlattQuery from './api-client/KonditionsBlattQuery';



export * as FirmwareClient from './api-client/FirmwareClient';

export * as FirmwareQuery from './api-client/FirmwareQuery';



export * as FilesClient from './api-client/FilesClient';

export * as FilesQuery from './api-client/FilesQuery';



export * as DeviceOverviewClient from './api-client/DeviceOverviewClient';

export * as DeviceOverviewQuery from './api-client/DeviceOverviewQuery';



export * as DeliveryObligationClient from './api-client/DeliveryObligationClient';

export * as DeliveryObligationQuery from './api-client/DeliveryObligationQuery';



export * as CustomersClient from './api-client/CustomersClient';

export * as CustomersQuery from './api-client/CustomersQuery';



export * as CmsPageClient from './api-client/CmsPageClient';

export * as CmsPageQuery from './api-client/CmsPageQuery';



export * as CmsPageVersionClient from './api-client/CmsPageVersionClient';

export * as CmsPageVersionQuery from './api-client/CmsPageVersionQuery';



export * as MainboardCertificateClient from './api-client/MainboardCertificateClient';

export * as MainboardCertificateQuery from './api-client/MainboardCertificateQuery';



export * as ArticlesClient from './api-client/ArticlesClient';

export * as ArticlesQuery from './api-client/ArticlesQuery';



export * as WebUsersClient from './api-client/WebUsersClient';

export * as WebUsersQuery from './api-client/WebUsersQuery';



export * as AbasFileClient from './api-client/AbasFileClient';

export * as AbasFileQuery from './api-client/AbasFileQuery';



export * as SignUrlClient from './api-client/SignUrlClient';

export * as SignUrlQuery from './api-client/SignUrlQuery';



export * as TestDataClient from './api-client/TestDataClient';

export * as TestDataQuery from './api-client/TestDataQuery';



export * as TransferUsersClient from './api-client/TransferUsersClient';

export * as TransferUsersQuery from './api-client/TransferUsersQuery';



export * as VersionClient from './api-client/VersionClient';

export * as VersionQuery from './api-client/VersionQuery';





import { addResultTypeFactory } from './api-client/helpers';
export { setBaseUrl, getBaseUrl } from './api-client/helpers';
export { setAxiosFactory, getAxios } from './api-client/helpers';


//-----PersistorHydrator.File-----
import type { PersistedClient } from '@tanstack/react-query-persist-client';
import type { DehydratedState, QueryKey } from '@tanstack/react-query'
import { getResultTypeFactory } from './api-client/helpers';

/*
 * If you have Dates in QueryKeys (i.e. in request parameters), you need to deserialize them to Dates correctly
 * (otherwise they are deserialized as strings by default, and your queries are broken).
 */
export function deserializeDate(str: unknown) {
  if (!str || typeof str !== 'string') return str;
  if (!/^\d\d\d\d\-\d\d\-\d\d/.test(str)) return str;
  
  const date = new Date(str);
  const isDate = date instanceof Date && !isNaN(date as any);
  
  return isDate ? date : str;
}

export function deserializeDatesInQueryKeys(queryKey: QueryKey) {
  return queryKey
    // We need to replace `null` with `undefined` in query key, because
    // `undefined` is serialized as `null`.
    // And most probably if we have `null` in QueryKey it actually means `undefined`.
    // We can't keep nulls, because they have a different meaning, and e.g. boolean parameters are not allowed to be null.
    .map(x => (x === null ? undefined : x))
    .map(x => deserializeDate(x));
}

export function deserializeClassesInQueryData(queryKey: QueryKey, data: any) {
  if (!data) {
    return data;
  } else if (typeof data !== 'object') {
    return data;
  } else if ('pages' in data && 'pageParams' in data && Array.isArray(data.pages) && Array.isArray(data.pageParams)) {
    // infinite query
    data.pages = data.pages.map((page:any) => deserializeClassesInQueryData(queryKey, page));
  } else if (Array.isArray(data)) {
    return data.map(elem => constructDtoClass(queryKey, elem));
  } else {
    return constructDtoClass(queryKey, data);
  }
}

/*
 * Pass this function as `deserialize` option to createSyncStoragePersister/createAsyncStoragePersister
 * to correctly deserialize your DTOs (including Dates)
 */
export function persisterDeserialize(cache: string): PersistedClient {
  const client: PersistedClient = JSON.parse(cache);
  client.clientState.queries.forEach((query) => {
    query.state.data = deserializeClassesInQueryData(query.queryKey, query.state.data);
    query.queryKey = deserializeDatesInQueryKeys(query.queryKey);
  });

  return client;
}

export function constructDtoClass(queryKey: QueryKey, data: any): unknown {
  const resultTypeKey = getResultTypeClassKey(queryKey);
  const constructorFunction = getResultTypeFactory(resultTypeKey);

  if (!data || !constructorFunction)
    return data;

  return constructorFunction(data);
}

export function getResultTypeClassKey(queryKey: QueryKey): string {
  if (!Array.isArray(queryKey)) {
    return queryKey as unknown as string;
  }
  if (queryKey.length >= 2) {
    // We concatenate first and second elements, because they uniquely identify the query.
    // All other QueryKey elements are query parameters
    return `${queryKey[0]}___${queryKey[1]}`;
  }

  // We actually should never reach this point :)
  return queryKey.join('___');
}

export function initPersister() {
  
  addResultTypeFactory('WarrantyRequestClient___requestDevice', (data: any) => Types.initWarrantyResponseDto(data));
  addResultTypeFactory('WarrantyRequestClient___searchReplacementPart', (data: any) => Types.initReplacementPartResponseDto(data));


  addResultTypeFactory('WarrantyRequestSummaryClient___get', (data: any) => Types.initWarrantyRequestSummaryResponseDto(data));


  addResultTypeFactory('WarrantyRequestBasketClient___get', (data: any) => Types.initBasketGetResponseDto(data));
  addResultTypeFactory('WarrantyRequestBasketClient___getCertainOrder', (data: any) => Types.initBasketCertainOrderResponseDto(data));
  addResultTypeFactory('WarrantyRequestBasketClient___searchLastAddedDevice', (data: any) => Types.initSameDeviceResponseDto(data));


  addResultTypeFactory('UserClient___getUserList', (data: any) => Types.initPagedResultOfUserListItemDto(data));
  addResultTypeFactory('UserClient___getCurrentUserInfo', (data: any) => Types.initUserEnumRolesDto(data));




  addResultTypeFactory('TelehealthBillingClient___get', (data: any) => Types.initTelehealthBillingResponseDto(data));




  addResultTypeFactory('ServicePresentationClient___get', (data: any) => Types.initServicePresentationResponseDto(data));


  addResultTypeFactory('ServiceAndRepairClient___get', (data: any) => Types.initResponseServiceAndRepairDto(data));


  addResultTypeFactory('SerialNumberClient___get', (data: any) => Types.initSerialNumberResponseDto(data));




  addResultTypeFactory('SearchClient___search', (data: any) => Types.initPagedResultOfSearchResultDto(data));
  addResultTypeFactory('SearchClient___advancedSearch', (data: any) => Types.initPagedResultOfSearchResultGroupedDto(data));




  addResultTypeFactory('RepairsClient___get', (data: any) => Types.initRepairsResponseDto(data));
  addResultTypeFactory('RepairsClient___getRepairOrdersForPdfGeneration', (data: any) => Types.initRepairsResponseDto(data));
  addResultTypeFactory('RepairsClient___getDetailsByIncomingNumber', (data: any) => Types.initRepairsDetailsDto(data));


  addResultTypeFactory('RepairsOrderClient___getInvoiceAddress', (data: any) => Types.initInvoiceAddressDto(data));
  addResultTypeFactory('RepairsOrderClient___getInternalRepairOrderInvoiceAddress', (data: any) => Types.initInvoiceAddressDto(data));
  addResultTypeFactory('RepairsOrderClient___getUserOpenRepairOrderDrafts', (data: any) => Types.initRepairOrderDraftListDto(data));
  addResultTypeFactory('RepairsOrderClient___requestDevice', (data: any) => Types.initRepairDeviceDto(data));
  addResultTypeFactory('RepairsOrderClient___getSalesView', (data: any) => Types.initSalesViewDto(data));
  addResultTypeFactory('RepairsOrderClient___printSales', (data: any) => Types.initSalesPrintDto(data));


  addResultTypeFactory('QualificationClient___get', (data: any) => Types.initPagedResultOfQualificationResponseDto(data));


  addResultTypeFactory('ProfessionalInfoClient___get', (data: any) => Types.initProfessionalInfoResponseDto(data));


  addResultTypeFactory('PriceListsClient___get', (data: any) => Types.initPriceListsResponseDto(data));


  addResultTypeFactory('PlanChartsClient___get', (data: any) => Types.initAbasExecuteResponse(data));


  addResultTypeFactory('OutstandingReceivablesClient___get', (data: any) => Types.initOutstandingReceivablesResponseDto(data));


  addResultTypeFactory('OrderListClient___get', (data: any) => Types.initResponseOrderListDto(data));


  addResultTypeFactory('NotificationClient___get', (data: any) => Types.initGetNotificationsResponseDto(data));


  addResultTypeFactory('KonditionsBlattClient___get', (data: any) => Types.initKonditionsBlattResponseDto(data));


  addResultTypeFactory('FirmwareClient___get', (data: any) => Types.initFwResponseDto(data));


  addResultTypeFactory('FilesClient___get', (data: any) => Types.initPagedResultOfFileInfoDto(data));
  addResultTypeFactory('FilesClient___get2', (data: any) => Types.initFileInfoDto(data));


  addResultTypeFactory('DeviceOverviewClient___get', (data: any) => Types.initResponseDeviceOverview(data));


  addResultTypeFactory('DeliveryObligationClient___get', (data: any) => Types.initAbasExecuteResponse(data));


  addResultTypeFactory('CustomersClient___getMyCustomerInfo', (data: any) => Types.initCustomerInfoDto(data));


  addResultTypeFactory('CmsPageClient___search', (data: any) => Types.initPagedResultOfCmsPageListItemDto(data));
  addResultTypeFactory('CmsPageClient___getDetailsById', (data: any) => Types.initCmsPageDto(data));
  addResultTypeFactory('CmsPageClient___getDetailsByUrl', (data: any) => Types.initCmsPageDto(data));


  addResultTypeFactory('CmsPageVersionClient___search', (data: any) => Types.initPagedResultOfCmsPageVersionDto(data));
  addResultTypeFactory('CmsPageVersionClient___getVersionDetails', (data: any) => Types.initCmsPageVersionDetailedDto(data));


  addResultTypeFactory('MainboardCertificateClient___getResult', (data: any) => Types.initReplacementResponseDto(data));


  addResultTypeFactory('ArticlesClient___get', (data: any) => Types.initAbasExecuteResponse(data));




  addResultTypeFactory('AbasFileClient___search', (data: any) => Types.initAbasFileResponseDto(data));










}
//-----/PersistorHydrator.File----